module.exports = __webpack_public_path__ + "img/ill_star@2x.9f5f7f44.png";